.a7{flex-direction:row;}